import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import authEn from './locales/en/auth.json'
import commonEn from './locales/en/common.json'
import dashboardEn from './locales/en/dashboard.json'
import validationEn from './locales/en/validation.json'
import drawingsEn from './locales/en/drawings.json'
import kidsEn from './locales/en/kids.json'
import directionsEn from './locales/en/directions.json'
import settingsEn from './locales/en/settings.json'
import invoicesEn from './locales/en/invoices.json'
import subscriptionEn from './locales/en/subscription.json'

import authUa from './locales/ua/auth.json'
import commonUa from './locales/ua/common.json'
import dashboardUa from './locales/ua/dashboard.json'
import validationUa from './locales/ua/validation.json'
import drawingsUa from './locales/ua/drawings.json'
import kidsUa from './locales/ua/kids.json'
import directionsUa from './locales/ua/directions.json'
import settingsUa from './locales/ua/settings.json'
import invoicesUa from './locales/ua/invoices.json'
import subscriptionUa from './locales/ua/subscription.json'


export const defaultNS = "common"
export const resources = {
  en: {
    common: commonEn,
    validation: validationEn,
    auth: authEn,
    dashboard: dashboardEn,
    drawings: drawingsEn,
    kids: kidsEn,
    directions: directionsEn,
    settings: settingsEn,
    invoices: invoicesEn,
    subscription: subscriptionEn,
  },
  "uk-UA": {
    common: commonUa,
    validation: validationUa,
    auth: authUa,
    dashboard: dashboardUa,
    drawings: drawingsUa,
    kids: kidsUa,
    directions: directionsUa,
    settings: settingsUa,
    invoices: invoicesUa,
    subscription: subscriptionUa
  }
} as const

i18n.use(LanguageDetector).use(initReactI18next).init({
  debug: true,
  detection: {
    order: ['querystring', 'localStorage', 'sessionStorage', 'cookie', 'navigator', 'htmlTag'],
  },
  fallbackLng: "uk-UA",
  ns: ["common", "auth", "validation", "dashboard", "drawings", "kids", "directions", "settings", "invoices", "subscription"],
  defaultNS,
  resources,
})

export default i18n
